import { ColumnHeader } from '@/interfaces/components/ColumnHeader';

const hydratedHeaders: ColumnHeader[] = [
  { text: 'venue.loyaltyManagedGifts.image', value: 'image', sortable: false },
  { text: 'venue.loyaltyManagedGifts.name', value: 'name' },
  { text: 'venue.loyaltyManagedGifts.type', value: 'giftType' },
  { text: 'venue.loyaltyManagedGifts.status', value: 'status' },
  { text: 'venue.loyaltyManagedGifts.requiredPoints', value: 'requiredPoints' },
  { text: '', value: 'actions', sortable: false },
];

export default hydratedHeaders;
